jQuery('#load-btn').on('click', function(event){
	event.preventDefault();
	if(window.news_params) {
		window.news_params.current_page++; 
		jQuery('#load-btn').addClass('loading');
		jQuery.ajax({
			type: 'POST',
			url: window.news_params.ajaxurl,
			dataType: 'html',
			data: {
				action: 'load_more_news',
				paged: window.news_params.current_page,
				params: window.news_params.posts,
			},
			success: function (res) {
				jQuery('#articles').append(res);
				jQuery('#load-btn').removeClass('loading');
			}
		});
		if(window.news_params.current_page >= window.news_params.max_page) {
			jQuery('#load-btn').hide();
		}
	}
});
